import controller from './advanced-information.controller';

const template = require('./advanced-information.html');

export default {
    bindings: {
        advancedInformation: '<'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/advanced-information/advanced-information.component.js